import React, { useEffect } from 'react';

import { MtxIcon } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

type ToastProps = {
  message: string;
  description: string;
  duration?: number;
  onClose: () => void;
};

const Toast: React.FC<ToastProps> = ({ message, description, duration = 4000, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={styles.toast}>
      <div className={styles.closeContent}>
        <span
          className={styles.closeButton}
          role="button"
          tabIndex={0}
          aria-label={t('common.closeNotification')}
          onClick={onClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') onClose();
          }}
        >
          <MtxIcon name="cross-circle" size={16} />
        </span>
      </div>
      <div className={styles.tosterText}>
        <p className={styles.message}> {message}</p>
        <p className={styles.descriptionToaster}>{description}</p>
      </div>
    </div>
  );
};

export default Toast;
